import {ComponentConfigurationClass} from "@zoovu/runner-browser-api";
import {ConfigurationValues, ValuesConfigurationConstructor} from "./values";

/**
 * @title Recommendation Settings
 * @format custom-hidden
 * @additionalProperties false
 */
@ValuesConfigurationConstructor(ConfigurationValues.Searchbar)
@ComponentConfigurationClass("searchbarConfiguration")
export class SearchbarConfiguration {

    /**
     * @title Show searchbar
     * @description If enabled, displays the searchbar on the results page
     */
    public showOnResultsSection?: boolean = false;

    /**
     * @title Show searchbar
     * @description If enabled, displays the searchbar on the questionnaire pages
     */
    public showOnQuestionnaireSection?: boolean = false;
}
